import { createSelector } from '@ngrx/store';
import { State } from '../../store/index';
import { AuthState } from '../auth.model';

export const authStateSelector = (state: State): AuthState => state.auth;

export const isAuthenticatedSelector = createSelector(authStateSelector, (state) => !!state.org);

export const isAdminSelector = createSelector(authStateSelector, (state) => state.roles?.includes('admin') || state.roles?.includes('superadmin'));

export const authOrgSelector = createSelector(authStateSelector, (state) => state.org);

export const authConfigIdSelector = createSelector(authStateSelector, (state) => state.configId);

export const orgEntriesSelector = createSelector(authStateSelector, (state) => state.orgEntries ?? []);

export const authScopesSelector = createSelector(authStateSelector, (state) => state.scopes);

export const authPermissionsSelector = createSelector(authStateSelector, (state) => state.permissions);

// ─── Deprecated stubs — removed in Phase 4 ───────────────────────────────────
// user.service.ts and request-info-dialog.component.ts reference subSelector.
// Returns '' so downstream code degrades gracefully.

/** @deprecated — JWT sub claim; replaced by OidcSecurityService.getUserData() in Phase 4 */
export const subSelector = createSelector(authStateSelector, (_state: AuthState) => '' as string);
